import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const RotationalSpeedConverterGuidePage = () => <DataDrivenGuidePage slug="guide-rpm-rad-converter" />;

export default RotationalSpeedConverterGuidePage;
